import onResize from './onResize';
import variantSelectors from './variantSelectors';

const ProductOverview = () => {
  // This needs to be on every page for quickview...kind of hacky, need to refactor later
  variantSelectors();
  onResize();

  const productJsonElement = document.querySelector('[data-section-type="product"] [data-product-json]');
  if (!productJsonElement) {
    return;
  }

  document.dispatchEvent(new CustomEvent('shouldProcessProductData'));

  // Ensure the right image is shown on the page
  const customVariantSelector = document.querySelector('[data-custom-variant-selector]');
  if (customVariantSelector && customVariantSelector.tagName === 'SELECT') {
    customVariantSelector.dispatchEvent(new Event('change'));
  } else {
    const selectedVariant = document.querySelector('.ProductOption__variant--selected');
    if (selectedVariant) {
      selectedVariant.click();
    }
  }

  // Adding an event listener for a custom event 'breakpointChange' if needed
  // window.addEventListener('breakpointChange', () => {
  //   initProductCarousels();
  // });
};

export { ProductOverview };
